export default __webpack_public_path__ + "static/media/cloudplexlogo.8ea3f686.png";